import React from 'react';
import { useContent } from '../hooks/useContent';
import './FloatingWhatsapp.css';

// Helper to convert phone number into a valid WhatsApp link
const getPhoneWhatsAppLink = (phone, fallback = 'https://wa.me/12482751077') => {
  if (!phone) return fallback;
  const digits = String(phone).replace(/[^0-9]/g, '');
  if (!digits) return fallback;
  const fullNumber = digits.length === 10 ? `1${digits}` : digits;
  return `https://wa.me/${fullNumber}`;
};

const FloatingWhatsapp = ({ phoneNumber = '12482751077' }) => {
  const { content } = useContent('navbar');
  const targetPhone = content?.phoneNumber || phoneNumber;
  const whatsappUrl = (content?.whatsappLink && content.whatsappLink.includes('12482751077'))
    ? content.whatsappLink
    : getPhoneWhatsAppLink(targetPhone);

  return (
    <div className="v2-floating-whatsapp-container">
      <div className="v2-whatsapp-tooltip">
        <span className="v2-whatsapp-status-dot"></span>
        <span>Chat with us on WhatsApp</span>
      </div>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="v2-floating-whatsapp-btn"
        aria-label="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default FloatingWhatsapp;
